import "./style.css";

export default class ProgramDetails {
  static selector = ".program-details-table";

  constructor(block) {
    
    this.block = block;
    this.showmoreButtons = this.block.querySelectorAll(".view-more-button");
   
    for (const button of this.showmoreButtons) {
      
      button.addEventListener("click", this.onViewMore);
    }
  }
  onViewMore = (e) => {
    e.preventDefault() ;
    const activeButton = e.currentTarget;
    const currentTabId = activeButton.dataset.id;
    const currentTab = this.block.querySelector("#"+currentTabId);
    currentTab.classList.toggle("active");
     
  };
  
}
